import { Button, Modal } from "antd";

const CustomModal = ({ title, visible, onCancel, onClose, action, actionName, body }) => {

    return (
        <Modal
            title={title}
            visible={visible}
            onCancel={onCancel}
            footer={[
                <Button key="back" onClick={onClose}>
                    Annuler
                </Button>,
                <Button
                    key="submit"
                    type="primary"
                    onClick={action}
                >
                    {actionName}
                </Button>,
            ]}
        >
            <p>{body}</p>
        </Modal>
    )
}
export default CustomModal;

